"use strict";

var _regeneratorRuntime = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.is-array");

require("regenerator-runtime/runtime");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.filter");

var _classCallCheck = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureHookManager = void 0;

var feature_1 = require("../log/feature");

var isPromise = function isPromise(item) {
  return !!item.then;
};
/**
 * {@inheritDoc IFeatureHookManager}
 */


var FeatureHookManager = /*#__PURE__*/function () {
  function FeatureHookManager() {
    _classCallCheck(this, FeatureHookManager);

    this.hookPayloads = [];
    this.registeredCallbacks = [];
    this.registeredMutateHooks = [];
  }
  /** {@inheritDoc IFeatureHookManager.registerHook} */


  _createClass(FeatureHookManager, [{
    key: "registerHook",
    value: function registerHook(name, invokeCallback) {
      (0, feature_1.debug)('register hook %s', name);
      this.registeredCallbacks.push({
        name: name,
        callback: invokeCallback
      });
      var payloads = this.hookPayloads.filter(function (payload) {
        return payload.name === name;
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = payloads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var payload = _step.value;
          invokeCallback(payload.callingFeature, payload.payload);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    /** {@inheritDoc IFeatureHookManager.hook} */

  }, {
    key: "hook",
    value: function hook(feature, name, payload) {
      (0, feature_1.debug)('hook %s, from %s', name, feature.constructor.name);
      this.hookPayloads.push({
        name: name,
        payload: payload,
        callingFeature: feature
      });
      var callbacks = this.registeredCallbacks.filter(function (c) {
        return c.name === name;
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = callbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var callback = _step2.value;

          if (callback.callback) {
            callback.callback(feature, payload);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    /** {@inheritDoc IFeatureHookManager.registerMutateHook} */

  }, {
    key: "registerMutateHook",
    value: function registerMutateHook(name, mutateCallback) {
      (0, feature_1.debug)('register mutate hook %s', name);
      this.registeredMutateHooks.push({
        name: name,
        callback: mutateCallback
      });
    }
    /** {@inheritDoc IFeatureHookManager.mutateHook} */

  }, {
    key: "mutateHook",
    value: function mutateHook(name, payload, context, opts) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref, _ref$reverse, reverse, result, hooks, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, registeredHook;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, feature_1.debug)('calling mutate hook %s', name);
                _ref = opts || {}, _ref$reverse = _ref.reverse, reverse = _ref$reverse === void 0 ? false : _ref$reverse;
                result = payload;
                hooks = this.registeredMutateHooks.filter(function (hook) {
                  return Array.isArray(name) ? name.includes(hook.name) : hook.name === name;
                });

                if (reverse) {
                  (0, feature_1.debug)('reversing hook order...');
                  hooks = _toConsumableArray(hooks).reverse();
                }

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 8;
                _iterator3 = hooks[Symbol.iterator]();

              case 10:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context.next = 18;
                  break;
                }

                registeredHook = _step3.value;
                _context.next = 14;
                return registeredHook.callback(result, context);

              case 14:
                result = _context.sent;

              case 15:
                _iteratorNormalCompletion3 = true;
                _context.next = 10;
                break;

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](8);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t0;

              case 24:
                _context.prev = 24;
                _context.prev = 25;

                if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                  _iterator3["return"]();
                }

              case 27:
                _context.prev = 27;

                if (!_didIteratorError3) {
                  _context.next = 30;
                  break;
                }

                throw _iteratorError3;

              case 30:
                return _context.finish(27);

              case 31:
                return _context.finish(24);

              case 32:
                return _context.abrupt("return", result);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 20, 24, 32], [25,, 27, 31]]);
      }));
    }
    /** {@inheritDoc IFeatureHookManager.mutateHookSync} */

  }, {
    key: "mutateHookSync",
    value: function mutateHookSync(name, payload, context, opts) {
      var _ref2 = opts || {},
          _ref2$reverse = _ref2.reverse,
          reverse = _ref2$reverse === void 0 ? false : _ref2$reverse;

      var result = payload;
      var hooks = this.registeredMutateHooks.filter(function (hook) {
        return Array.isArray(name) ? name.includes(hook.name) : hook.name === name;
      });

      if (reverse) {
        (0, feature_1.debug)('mutate hook (sync): reversing hook order...');
        hooks = _toConsumableArray(hooks).reverse();
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = hooks[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var registeredHook = _step4.value;
          var hookResult = registeredHook.callback(result, context);

          if (isPromise(hookResult)) {
            throw new Error('A promise was returned when mutateHookSync() was called');
          }

          result = hookResult;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
            _iterator4["return"]();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return result;
    }
  }]);

  return FeatureHookManager;
}();

exports.FeatureHookManager = FeatureHookManager;